// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"MoreInfoOfferLink_moreButton__2DZkF"};